import React from 'react';
import locales from '../../locales/LocalesManager';
import mouseUtils from '../../components/utils/MouseUtils';
import downloadUtils from '../../components/utils/DownloadUtils';
import appParameters from '../../components/utils/AppParameters';
import properties from '../../constants/Properties';
import configuration from '../../constants/Configuration';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onButtonClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.index == 1) { // Go back to Dashboard
            if (!appParameters.isExportTab)
                window.location.href = appParameters.backToDashboardLink;
            else {
                if (configuration.IS_PROD())
                    window.location.href = 'https://www.creaza.com/portfolio/myFiles/exported#/myFiles/exported';
                else
                    window.location.href = 'https://stage.creaza.com/portfolio/myFiles/exported#/myFiles/exported';
            }
        } else { // Export video
            this.props.updateState(true, false);

            downloadUtils.download(appParameters.downloadId);
        }
    },
    render() {
        var textColor;
        var fillColor;

        if (this.state.isOver) {
            fillColor = properties.SLIDE_VIEWER_BACKGROUND;
            textColor = 'black';
        } else {
            textColor = 'black';
            fillColor = 'white';
        }

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: fillColor,
            width: this.props.width,
            height: this.props.height,
            top: this.props.topPosition,
            left: this.props.leftPosition,
            borderRadius: 10,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#333333'
        };

        const spanStyle = {
            position: 'absolute',
            top: 20,
            fontSize: 18,
            width: this.props.width - 6,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            alignItems: 'center',
            textAlign: 'center',
            cursor: 'default',
            color: textColor
        };

        return (
            <div style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onButtonClick} onClick={this.onButtonClick}>
                <span style={spanStyle}>{this.props.text}</span>
            </div>
        );
    }
});

export const DownloadPage = React.createClass({
    getInitialState () {
        return {
            isDownloadStarted: false,
            isDownloadFinished: false
        };
    },
    componentDidMount() {
        downloadUtils.downloadFinishedCallback = this.downloadFinished;
        downloadUtils.checkType();
    },
    downloadFinished() {
        this.setState({
            isDownloadStarted: false,
            isDownloadFinished: true
        });
    },
    updateState(isDownloadStarted, isDownloadFinished) {
        this.setState({
            isDownloadStarted,
            isDownloadFinished
        });
    },
    render () {
        const width = this.props.windowWidth - 200;
        const height = 200;
        const buttonWidth = 200;
        const buttonHeight = 60;
        const gap = 20;
        var topPosition;

        const menuStyle = {
            position: 'absolute',
            width: width,
            height: height,
            top: this.props.windowHeight / 2 - height / 2,
            left: this.props.windowWidth / 2 - width / 2
        };

        const spanStyle = {
            position: 'absolute',
            width,
            height,
            fontSize: 20,
            WebkitUserSelect: 'none',
            userSelect: 'none',
            textAlign: 'center',
            cursor: 'default',
            top: 0
        };

        topPosition = height - buttonHeight - gap;

        var elements = [];
        var text;
        var goBackPosition;
        var downloadPosition;

        if (this.state.isDownloadStarted) {
            text = locales.getCaption('downloadStarted', 'download');

            const size = 48;

            const loaderStyle = {
                position: 'absolute',
                top: height - buttonHeight - gap,
                left: width / 2 - size / 2,
                color: 'black'
            };

            elements.push(<i style={loaderStyle} key='download3' className="fa fa-spinner fa-pulse fa-3x" />);
        } else if (this.state.isDownloadFinished) {
            text = locales.getCaption('finished', 'download');
            goBackPosition = width / 2 - buttonWidth / 2;
            elements.push(<Button topPosition={topPosition} leftPosition={goBackPosition} width={buttonWidth} height={buttonHeight} index={1} updateState={this.updateState} key='download3' text={locales.getCaption('backToDashboardAfterDownload', 'download')}/>);
        } else {
            text = locales.getCaption('downloadToCameraRoll', 'download');
            downloadPosition = width / 2 - gap / 2 - buttonWidth;
            goBackPosition = width / 2 + gap / 2;
            elements.push(<Button topPosition={topPosition} leftPosition={downloadPosition} width={buttonWidth} height={buttonHeight} index={0} updateState={this.updateState} key='download1' text={locales.getCaption('download', 'download')}/>);
            elements.push(<Button topPosition={topPosition} leftPosition={goBackPosition} width={buttonWidth} height={buttonHeight} index={1} updateState={this.updateState} key='download2' text={locales.getCaption('backToDashboard', 'download')}/>);
        }

        return (
            <div style={menuStyle}>
                <span style={spanStyle}>{text}</span>
                {elements}
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/DownloadPage.js
 **/